import find from 'lodash/find'
import store from '../../store'
import { formatSubjectToString } from '../formatSubjectToString'
import analytics from '../cdpAnalytics'

export function copyItemFromRepoEvent(item, initiatedFrom) {
  const state = store.getState()
  let itemType = ''
  let itemName = ''
  if (item.questions) {
    itemType = 'set'
    itemName = item.name
  } else {
    itemType = 'question'
    itemName = item.body
  }
  const repoId = item.repo
  const repo = find(state.repos, { id: repoId }) || {}

  const formattedSubject = formatSubjectToString(repo.subject)
  if (repo.published) {
    const userIsAuthor = repo.role === 'author'
    analytics.track('Copy item out of public repo', {
      itemType,
      itemId: item.id,
      itemName,
      repoId,
      repoName: repo.name,
      repoSubject: formattedSubject,
      repoLanguage: repo.language,
      repoGradeArray: repo.grade,
      repoAuthorUsername: repo.author.username,
      reopDescription: repo.description,
      initiatedFrom,
      userIsAuthor,
    })
  } else {
    analytics.track('Copy item out of view only private shared', {
      itemType,
      itemId: item.id,
      itemName,
      repoId,
      repoName: repo.name,
      repoSubject: formattedSubject,
      repoLanguage: repo.language,
      repoGradeArray: repo.grade,
      reopDescription: repo.description,
      initiatedFrom,

    })
  }
}
